"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var LinearProgress_1 = __importDefault(require("@material-ui/core/LinearProgress"));
var FormControl_1 = __importDefault(require("@material-ui/core/FormControl"));
var FormLabel_1 = __importDefault(require("@material-ui/core/FormLabel"));
var FormHelperText_1 = __importDefault(require("@material-ui/core/FormHelperText"));
var styles_1 = require("@material-ui/core/styles");
var Field_1 = require("../Field");
var utils_1 = require("./utils");
var classnames_1 = __importDefault(require("classnames"));
__export(require("./utils"));
function useBooleanControls(initial) {
    if (initial === void 0) { initial = false; }
    var _a = react_1.useState(initial), value = _a[0], setValue = _a[1];
    var setTrue = function () { return setValue(true); };
    var setFalse = function () { return setValue(false); };
    return { value: value, actions: { setTrue: setTrue, setFalse: setFalse } };
}
var useStyles = styles_1.makeStyles(function (theme) { return ({
    root: {
        borderRadius: 4,
        display: 'flex',
        borderColor: 'rgba(255, 255, 255, 0.23)',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid',
        width: '100%',
    },
    hovering: {
        borderColor: 'rgba(255, 255, 255, 1)',
    },
    dragging: {
        borderColor: theme.palette.primary.main,
    },
    error: {
        borderColor: theme.palette.primary.main,
    },
    loader: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
    },
}); });
exports.UploadField = function (_a) {
    var _b = _a.name, name = _b === void 0 ? '' : _b, onUpload = _a.onUpload, props = __rest(_a, ["name", "onUpload"]);
    var uploading = useBooleanControls();
    var _c = react_1.useState(''), preliminaryUrl = _c[0], setPreliminaryUrl = _c[1];
    var _d = Field_1.useFormFieldContext(name), state = _d.state, actions = _d.actions;
    var handleChange = function (ev) { return __awaiter(void 0, void 0, void 0, function () {
        var file, base64Url, url, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    file = ev.target.files[0];
                    if (!file)
                        return [2 /*return*/];
                    uploading.actions.setTrue();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, utils_1.readFile(file)];
                case 2:
                    base64Url = _a.sent();
                    setPreliminaryUrl(base64Url);
                    return [4 /*yield*/, handleUpload(file, base64Url)];
                case 3:
                    url = _a.sent();
                    actions.setValue(url);
                    setPreliminaryUrl('');
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    actions.setError(e_1.message);
                    setPreliminaryUrl('');
                    return [3 /*break*/, 5];
                case 5:
                    uploading.actions.setFalse();
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpload = function (file, base64Url) {
        if (onUpload)
            return onUpload(base64Url, file);
        return base64Url;
    };
    return (react_1.default.createElement(exports.ImageInput, __assign({}, props, { name: name, value: preliminaryUrl || state.value, error: state.hasError, helperText: state.error || props.helperText || '', onChange: handleChange, uploading: uploading.value })));
};
exports.ImageInput = function (_a) {
    var _b;
    var _c = _a.name, name = _c === void 0 ? '' : _c, _d = _a.label, label = _d === void 0 ? '' : _d, _e = _a.value, value = _e === void 0 ? '' : _e, _f = _a.className, className = _f === void 0 ? '' : _f, _g = _a.mainText, mainText = _g === void 0 ? 'Drop Image Here' : _g, _h = _a.height, height = _h === void 0 ? 200 : _h, _j = _a.uploading, uploading = _j === void 0 ? false : _j, _k = _a.helperText, helperText = _k === void 0 ? '' : _k, _l = _a.fullWidth, fullWidth = _l === void 0 ? true : _l, _m = _a.onChange, onChange = _m === void 0 ? function (ev) { return console.warn('Image set'); } : _m, _o = _a.accept, accept = _o === void 0 ? 'image/*' : _o, _p = _a.error, error = _p === void 0 ? false : _p;
    var classes = useStyles();
    var hover = useBooleanControls(false);
    var dragover = useBooleanControls(false);
    return (react_1.default.createElement(FormControl_1.default, { error: error, component: "div", fullWidth: fullWidth },
        react_1.default.createElement(FormLabel_1.default, { style: { display: 'block' }, htmlFor: name + "-file" }, label),
        react_1.default.createElement("div", { style: { height: height }, className: classnames_1.default(classes.root, (_b = {},
                _b[classes.dragging] = dragover.value,
                _b[classes.hovering] = hover.value,
                _b[classes.error] = error,
                _b)) },
            uploading ? (react_1.default.createElement("div", { className: classes.loader },
                react_1.default.createElement(LinearProgress_1.default, null))) : null,
            value ? (react_1.default.createElement("img", { src: value, alt: name, style: {
                    objectFit: 'contain',
                    objectPosition: 'center',
                    width: '100%',
                    height: '100%',
                } })) : (react_1.default.createElement(FormLabel_1.default, { htmlFor: name + "-file" }, mainText)),
            react_1.default.createElement("input", { type: "file", accept: accept, id: name + "-file", onMouseEnter: hover.actions.setTrue, onMouseLeave: hover.actions.setFalse, onTouchStart: hover.actions.setTrue, onTouchEnd: hover.actions.setFalse, onDragOver: dragover.actions.setTrue, onDragEnter: dragover.actions.setTrue, onDragLeave: dragover.actions.setFalse, onDragEnd: dragover.actions.setFalse, onDrop: dragover.actions.setFalse, onChange: onChange, style: {
                    top: 0,
                    left: 0,
                    opacity: 0,
                    position: 'absolute',
                    cursor: 'pointer',
                    width: '100%',
                    height: '100%',
                } })),
        react_1.default.createElement("input", { name: name, hidden: true, value: value, readOnly: true }),
        helperText ? (react_1.default.createElement(FormHelperText_1.default, { variant: "outlined" }, helperText)) : null));
};
//# sourceMappingURL=index.js.map